import styled from "styled-components";

export const Billing = styled.div`
  .planCancel{
    color: #FF5666;
    padding: 4px 10px 0 10px;
    height: 23px;
    font-size: 15px;
    font-weight: bold;
    font-family: 'Quicksand', sans-serif;
  }

  .box {
      width: 100%;
      height: 55px;
      display: flex;
      align-items: center !important; ;
      justify-content: space-between !important; ;
      margin-top: 13px !important;
      flex-direction: row;
      padding: 15px 10px 20px 10px;
      background-color: #fff;

      &:nth-child(1) {
          margin-top: 20px !important;
      }

      &:nth-child(2) {
          margin-top: 20px !important;
      }


      .topBox {
          display: flex !important; ;
          align-items: center !important; ;

          h2 {
              margin-left: 15px !important;
              font-size: 20px;
              font-weight: bold;
          }
      }

      .titleBox{
          h2 {
              color: #004FFF;
              font-size: 16px;
              font-weight: bold;
              margin: 5px 15px 5px 60px;
          }
      }

      .boxInfo {
        display: flex;
        width: 100%;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px 0 10px;
        flex-wrap: wrap;
        margin: 0 !important;

        @media(max-width: 720px) {
          gap: 30px;
          padding: 0px !important;
        }

        .infoBilling {
          flex-direction: column;

          h2 {
            font-size: 13px;
            color: #403F4C;
            font-weight: bold;
            margin: 0;
            padding: 0
          }

          h3 {
            font-size: 13px;
            color: #403F4C;
            font-weight: normal;
            margin: 0;
            padding: 0;
            text-align: left;
            max-width:initial;
          }

          span {
            color: #00D36A;
            font-weight: bold;
            display: flex;
            align-items: center;
            width: 100%;
            min-width: 55px;
          }
        }

        .word-wrap-break {
          word-break: break-all;
          width: 25%;
        }
      }

  }

  .buttons{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-end;
      margin: 25px 35px 25px 0;
      padding: 0 15px 0 15px;
      cursor: pointer;

      button {
          background-color: transparent;
          border: 1px solid #787780;
          color: #403F4C;
          font-weight: bold;
          font-size: 11px;
          border-radius: 26px;
          width: 71px;
          height: 28px;
          margin-top: 8px;
          margin-right: 10px;
          cursor: pointer;
      }

          .fa{
              margin-right: 7px;
          }
  }
`;

export const Form = styled.div`
    width: 100%;

    /* icons */
    .icons {
        padding-top: 40px;
        padding-bottom: 35px;
        margin: 0 auto;
        width: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #C5C3C9;
        font-weight: bold;

        &.active{
            color: var(--color-blue);
        }
        span{
            display: flex;
            width: 500px;
        }
        hr{
            border-top: 1px solid #C5C3C9;
            width: 40%;
            margin: 0;
            padding: 0;
            justify-content: end;
            display: flex;
            margin-top: 50px;

        }

        .icons-inner {
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            svg{
                margin-bottom: 12px;

            }
        }

        .icons-inner-active {
            color: var(--color-blue);
            display: flex;
            flex-direction: column;
            align-items: center;
            text-align: center;

            /* svg{
                height: 25px;
                width: 18px;
                margin-bottom: 10px;
            } */
        }
    }


    .singIn{
        margin-top: 25px;
        border-right: 1px solid #E4E8EE;
        width: 94%;
        margin-left: 6%;

        form{

            label{
                font-size: 14px;
                color: #403F4C;
                font-weight: 500;
            }

            span{
                font-size: 10px;
                color: #97979E;
                margin-bottom: 3px;
                margin-left: 6px;
            }

            input{
                width: 90%;
                height: 29px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                padding-top: 4px;
                opacity: 0.4;
            }

            select{
                width: 90%;
                height: 34px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                opacity: 0.4;
            }

            ::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
                margin-top: 10px;
                color: #403F4C;
            }


        }

        .footerSingIn {
            position: relative;
            font-weight: 200;
            width: 100%;
            display: flex;
            flex-direction: row;
            -ms-flex-align: center;
            align-items: center;
            margin-top: 20px;

            hr {
                width: inherit;
                margin: 0;
                height: 1px;
            }

            div {
                width: 100%;
                position: absolute;
                display: -ms-flexbox;
                display: flex;
                -ms-flex-pack: center;
                justify-content: center;
                -ms-flex-align: center;
                align-items: center;
            }

            .or-login-css {
                display: -ms-flexbox;
                display: flex;
                width: auto;
                padding-left: 10px;
                padding-right: 10px;
                padding-bottom: 5px;
                background-color: white;
                font-size: 12px;
            }

            .password{
                display: flex;
                height: 100%;
                width: 86%;
                align-items: center;
                justify-content: space-between;

                .forgot{
                    a{
                        color: #403F4C;
                        font-size: 12px;
                        text-decoration: underline;
                    }
                }
            }


        }

        .form-footer {
            height: 30px;
            width: 95%;
        }

        .form-footer_social-login{
            display: flex;
            justify-content: center;
            margin: 20px;

            img{
                width: 32px;
                height: 32px;
                margin: 0 30px 0 0;
            }
        }

        .switch__container{
            justify-content: center;
            text-align: center;
        }

        .switch--shadow + label {
            width: 32%;
        }

    }

    /* Verificar */
    .singIn{
        .account{
            display: flex;
            justify-content: center;
            align-items: center;
            margin-bottom: 35px;

            p{
                font-size: 14px;
            }

            a{
                color: #004FFF;
                font-weight: bold;
            }
        }
    }


    /** Text Prices **/
    .boxChangePlans{
        width: 100%;

        .textPrices{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin: 40px 0 10px 0;


            h2{
                color: #403F4C;
                font-size: 22px;
            }

            h3{
                color: #403F4C;
                font-size: 12px;
                margin: 0 0 12px 0;
            }

            .languageBoxes {
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: row;

                .languageBox{
                    min-width: 121px;
                    max-width: 121px;
                    display: flex;
                    margin: 0 20px 0 20px;
                    padding: 8px 5px 8px 5px;
                    border: solid 1px #706F79;
                    border-radius: 6px;
                    justify-content: center;
                    align-items: center;
                    cursor: pointer;
                }
            }
        }

        .buttonBack{
            display: flex;
            width: 95%;
            justify-content: flex-end;
            align-items: center;
            margin: 26px 0 20px 0;

            button{
                background-color: transparent;
                border: 1px solid #787780;
                border-radius: 26px;
                width: 71px;
                height: 32px;
                cursor: pointer;
            }

            img{
                margin: 0 0 0 25px;
            }

        }

    }


    /** Change Plan **/
    .boxChange{
        background-color: #fff;
        width: 100%;
        height: 130px;
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-bottom: 10px;
        justify-content: space-between;

        .changePlan{
            display: flex;
            align-items: center;
            flex-direction: column;
            /* padding: 23px; */
            margin:0 23px 0 13px;

            h2{
                color: #39ADFE;
                font-size: 18px;
                text-align: center;
                font-family: 'Work Sans',sans-serif;
                font-weight: bold;
                margin: 10px 0 0 0 !important;
                width: 100%;
                max-width: 133px;
                width: max-content;
            }

            h3{
                color: #004FFF;
                font-size: 12px;
                font-weight: bold;
                margin: 4px 0 0 0;
                max-width: 100%;
                font-family: 'Work Sans', sans-serif;
            }

            h4{
                color: #403F4C;
                font-size: 16px;
                font-weight: normal;
                text-decoration: line-through;
                margin: 0;
                opacity: 0.5;
                font-family: 'Work Sans', sans-serif;
            }

            h5{
                color: #004FFF;
                font-size: 24px;
                font-weight: bold;
                margin: 0;
            }

            h6{
                color: #6D6A75;
                font-size: 14px;
                font-weight: normal;
                margin: 0;
                font-family: 'Work Sans', sans-serif;
            }

            p{
                color: #6D6A75;
                font-size: 14px;
                font-family: 'Work Sans', sans-serif;
                opacity: 85
            }

            button{
                background-color: #004FFF;
                color: #fff;
                width: 80px;
                height: 40px;
                border-radius: 20px;
                border: none;
                font-weight: bold;
                font-family: 'Work Sans', sans-serif;
                cursor: pointer;
            }
        }

        .off{
            width: auto;
            height: 18px;
            background-color: #004FFF;
            border-radius: 4px;
            color: #fff;
            text-align: center;
            font-size: 12px;
            font-weight: bold;
            font-family: 'Work Sans', sans-serif;
            display: flex;
            align-items: center;
            padding: 0 6px 0 6px;
        }

    }


    /** Review **/
    .boxBig{
        background-color: transparent;
        width: 90%;
        height: 100%;
        display: flex;
        flex-direction: row;
        border-radius: 4px;
        margin-bottom: 50px;
        padding-top: 10px;
        margin: 0 auto;


        hr{
            height: 1px;
            width: 100%;
            margin: 45px 0 45px 0;
        }

        .box{
            width: 100%;
            height: 100%;
            padding: 20px 20px 0 30px;
        }

        .buttonBack{
            display: flex;
            width: 95%;
            justify-content: flex-end;
            align-items: center;
            margin: 26px 0 20px 0;

            button{
                background-color: transparent;
                border: 1px solid #787780;
                border-radius: 26px;
                width: 71px;
                height: 32px;
                cursor: pointer;
            }

            img{
                margin: 0 0 0 25px;
            }

        }


        /** change **/
        .change{
            display: flex;
            align-items: center;
            margin-top: 25px;

            h2{
                font-size: 22px;
                color: #403F4C;
                font-weight: bold;
            }

            i{
                font-size: 12px;
                color: #97979E;
                margin: 3px 0 0 8px;

                img{
                    margin: 0 0 0 2px;
                }
            }
        }


        .infos{

            h3{
                font-size: 14px;
                color: #403F4C;
                font-weight: normal;
            }

            h4{
                font-size: 20px;
                color: #403F4C;
                margin: 5px 0 10px 0;
            }

            p{
                font-size: 14px;
                color: #6D6A75;
                font-weight: normal;
                margin: 9px 8px 0 0;
            }
        }

        .reviewPlan{
            display: flex;
            flex-direction: column;
            max-width: 100%;
        }

        .textPlanTop{
            display: flex;
            flex-direction: row;
            width: 100%;
            margin-bottom: 25px;

            img{
                margin: 20px 10px 0 0;
            }

            h4{
                color: #39ADFE;
                padding-top: 0;
                margin: 18px 0 0;

            }

        }

        .textPlan{
          display: flex;
          flex-direction: row;
          align-items: center;
          width: 100%;
        }

        .infoPlan{
            display: flex;
            justify-content: space-between;
            flex-direction: column;
            width: 100%;
            margin: 0 0 10px 0;

            h5{
                margin: 5px 0 10px 0;
                color: #97979E;
            }

            select {
                width: 150px;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                margin-right: 10px;
                opacity: 0.4;
            }

            .language{
                display: flex;
                margin: 0 10px 0 0;

                h5{
                    margin: 0 0 0 6px;
                    text-align: left;
                    color: #403F4C;
                    font-size: 14px;
                }

                .input-lingo{
                    height: 32px;
                }
            }

            .textBottom{
                display: flex;
                width: 100%;
            }


        }

        .textBottom{
            display: flex;
            justify-content: flex-end;

            select {
                width: auto;
                height: 32px;
                border-radius: 26px;
                border: 1px solid #403F4C;
                padding-left: 10px;
                margin-bottom: 15px;
                color: #403F4C;
                margin-right: 10px;
                opacity: 0.4;
            }
        }

        .textPay{
            display: flex;
            justify-content: flex-end;
            width: 98%;
            text-align: right;
            margin: 20px 0 30px 0;

            .total{

                h5{
                    font-size: 15px;
                    color: #403F4C;
                    font-weight: bold;
                    opacity: 0.4;
                    margin: 65px 0 0 0;
                }
            }

            .price{
                h5{
                    font-size: 28px;
                    color: #004FFF;
                    font-weight: bold;
                    margin: 0;
                }

                span{
                    font-size: 14px;
                    color: #6D6A75;
                }
            }

            .dollar{
                span{
                    font-size: 12px;
                    color: #6D6A75;
                }
            }

        }
    }


    .review{
        .box{
            &:first-child {
                display:none;
            }

            &:nth-child(2) {
                display: table;
	            width: 100%;
            }

        }
    }

    /** Confirmation **/
    .confirmation{
        display: flex;
        width: 100%;
        justify-content: center;
        margin-top: 40px;

        h2{
            color: #00D36A;
            font-size: 22px;
            font-weight: bold;
            text-align: center;
        }

        img{
            margin: 25px auto;
            display: flex;
        }

        p{
            display: flex;
            font-size: 16px;
            color: #403F4C;
            text-align: center;
            margin-bottom: 50px;
        }

    }

    /* classe retirar depois */
    .fix-big{
        width: 90% !important;
        margin: 0 auto;
        padding-top: 10px;
    }

`;

export const Buttons = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-end;
    margin: 0;

    .footer-btns{
        display: flex;
        justify-content: space-between;
        width: 100%;

        .button{
            color: #fff;
            font-size: 14px;
            font-weight: bold;
            width: 200px;
            height: 38px;
            border-radius: 26px;
            background-color: #004FFF;
            border:  none;
            cursor: pointer;
            margin-top: 50px;
        }

        a{
            color: #FF5666;
            font-size: 12px;
            font-weight: 500;
            margin-right: 10px;
            text-decoration: none;
        }

        .save{
                button{
                    color: #787780;
                    font-size: 14px;
                    font-weight: bold;
                    width: 71px;
                    height: 32px;
                    border-radius: 26px;
                    background-color: transparent;
                    border: none;
                    cursor: pointer;
                    border: 1px solid #787780;
                    margin-top: 4px;
            }
        }
    }

    .buttonBack{
        display: flex;
        width: 100%;
        justify-content: flex-end;
        align-items: center;
        margin: 33px 0 20px 0;

        button{
            background-color: transparent;
            color: #787780;
            border: 1px solid #787780;
            border-radius: 26px;
            width: 71px;
            height: 32px;
            cursor: pointer;
        }

        img{
            margin: 0 0 0 25px;
        }

    }

`;

export const DowngradeUpgradeStyles = styled.div`
  gap: 12px;
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  margin: 30px 0;

  @media(max-width: 720px) {
    button {
      height: 40px;
    }
  }
`;

export const ManageAccountStyles = styled.div`
  width: 95%;
  margin: 0 auto;
  max-width: 1300px;

  h3{
    width: 100%;
    max-width: 66%;

    color: #004FFF;
    font-size: 22px;
    margin: 10px 0;
    font-weight: bold;
    text-align: center;
    font-family: 'Quicksand', sans-serif;
  }

  .labelNotify{
    width: auto;
    display: flex;
    flex-direction: column;

    .doubleClick{
      color: #ccc !important;
    }
  }

  .tabs{
    width: 100%;

    .content{
      width: 100%;
      display: flex;
      flex-direction: column;

      @media(max-width: 720px) {
        width: 95%;
        margin: 0;
      }

      .card{
        width: 97%;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        background-color: #fff;

        gap: 10px;
        margin-top: 25px;
        padding: 15px 15px;
        border-radius: 10px;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        @media(max-width: 720px) {
          align-items: center;
        }

        .changePhoto{
          display: flex;
          align-items: center;
          justify-content: center;
          flex-direction: column;
          width: 20%;

          h2 {
            color: #403F4C;
            font-size: 14px;
            margin: 0 0 10px 0 !important;
          }

          .photo{
            display: flex;
            align-items: center;
            flex-direction: column;
          }

          .fileUpload {
            position: relative;
            overflow: hidden;
            margin: 10px;
            border-radius: 26px;
            border: 1px solid #787780;
            width: 93px;
            height: 20px;
            text-align: center;
            font-size: 12px;
            display: flex;
            align-items: center;
            justify-content: center;

            input.upload {
              position: absolute;
              top: 0;
              right: 0;
              margin: 0;
              padding: 0;
              font-size: 20px;
              cursor: pointer;
              opacity: 0;
              filter: alpha(opacity=0);
            }

            span{
              display: flex;
              align-items: center;
            }
          }

          span{
            img{
              padding: 0 5px 0 0;
            }
          }
        }

        .wrapperBlock {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin: 20px 0;
          border-bottom: 3px solid #d5d5d9;

          button {
            margin: 0 0 12px 0 !important;
          }
        }

        .textBlock {
          color: #5778FB;
          font-size: 24px;
          font-weight: 700;
          line-height: 30px;
          padding-bottom: 12px;
        }

        .formulario{
          display: flex;
          justify-content: center;
          flex-direction: column;

          @media(max-width: 850px) {
            width: 100%;
          }

          label{
            color: #403F4C;
            font-size: 14px;
            font-weight: bold;
          }

          .addEmail{
            display: flex;

            input{
              width: 460px;
            }
          }

          .label{
            margin: 0 0 -15px 0;
          }

          span{
            color: #87868F;
            font-size: 10px;
            margin-left: 5px;
          }

          span.invalid {
            color: red;
            font-size: 10px;
            margin-left: 5px;
          }

          select{
            width: 228px;
            height: 32px;

            margin-top: 2px;
            padding-left: 10px;
            border-radius: 26px;
            margin-bottom: 15px;
            border: 1px solid #B2B2B7;

            color: #403F4C;
            font-size: 14px;
            font-family: 'Quicksand',sans-serif;

            @media(max-width: 720px) {
              width: auto;
            }

            &::placeholder {
              color: #87868F;
            }
          }

          input{
            width: 460px;
            height: 32px;

            padding: 0 10px;
            margin: 2px 0 15px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;

            font-size: 14px;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            background-color: transparent;

            @media(max-width: 720px) {
              width: auto;
            }

            &::placeholder {
              color: #87868F;
            }
          }

          .selectClass{
            pointer-events: none;
            touch-action: none;


            .classToolId{
              pointer-events: all;
              touch-action: unset;
              margin-top: 10px;
            }

            select, input{
              border: none;
              background-image: none;
              padding: 0;
            }

            span{
              display: none;
            }
          }

          .wrapperSelectTeacher {
            gap: 15px;
            display: flex;
            flex-direction: row;
            align-items: center;
            margin: 0 0 13px;

            .buttonSelectTeacher {
              width: 130px;
              height: 28px;
              border-radius: 26px;
              background-color: #fff;
              border: 1px solid #b2b2b7;
              margin: 0;

              color: #b2b2b7;
              font-size: 14px;
              cursor: pointer;

              @media(max-width: 720px) {
                width: 145px;
              }

              &:hover {
                filter: brightness(0.9);
              }
            }

            .buttonSelectTeacherActive {
              color: #fff;
              background-color: #004fff;
              border: 1px solid #004fff;
            }

            .wrapperInfoBilingue {
              border-radius: 10px;
              background: #004FFF;
            }

            .textInfoBilingue {
              text-align: justify;
            }

            .linguitoPNG {
              width: 45px;
              height: 35px;
            }
          }

          .wrapperLanguage {
            margin-bottom: 25px;
            border-bottom: 3px solid #d5d5d9;

            .languageMain{
              width: 100%;
              display: flex;
              flex-direction: column;

              select {
                @media(max-width: 720px) {
                  width: 100%;
                }
              }
            }

            .divSeparation{
              width: 100%;
              display: flex;
              margin-bottom: 20px;
              border-bottom: 1px solid #d5d5d9;
            }

            .otherLanguage{
              .wrapperLabel {
                width: 100%;
                display: flex;
                margin-bottom: 10px !important;

                label {
                  color: #5778FB;
                  font-size: 18px;
                  font-style: normal;
                  font-weight: 700;
                  line-height: normal;

                  margin-bottom: 13px;
                }
              }

              .wrapperOtherLanguage{
                width: 100%;
                display: flex;
                gap: 25px;
                flex-wrap: wrap;
                align-items: center;

                div {
                  @media(max-width: 675px) {
                    width: 100% !important;
                  }
                }

                select {
                  margin-right: 10px;

                  @media(max-width: 675px) {
                    width: 100% !important;
                  }
                }

                .buttonRemovelanguage {
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  width: 35px;
                  height: 35px;
                  margin: 0 0 15px 0;
                  border-radius: 50%;
                  background: transparent;
                  border: 1px solid #FF5666;
                  color: #FF5666;
                  cursor: pointer;
                  font-size: 11px;
                  font-weight: bold;
                }
              }
            }
          }

          .wrapperTaxInformation {
            display: flex;
            flex-direction: column;

            .labelEmpty {
              @media(max-width: 720px) {
                display: none;
              }
            }
          }

          .wrapperPayment {
            gap: 20px;
            display: flex;
            flex-direction: row;
            align-items: center;

            @media(max-width: 720px) {
              gap: 0;
              flex-direction: column;
            }

            div {
              display: flex;
              flex-direction: column;

              @media(max-width: 720px) {
                width: 100%;
              }

              input {
                width: 140px;
              }
            }

            div:nth-child(2){
              display: flex;
              flex-direction: column;

              input {
                width: 232px;

                @media(max-width: 720px) {
                  width: auto;
                }
              }
            }
          }

          .wrapperSelectHours {
            .wrapperSelectHoursButons {
              gap: 15px;
              display: flex;
              flex-direction: row;
              align-items: center;
              margin: 3px 0 13px;

              .buttonSelectHours {
                width: 130px;
                height: 28px;
                border-radius: 26px;
                background-color: #fff;
                border: 1px solid #b2b2b7;
                margin: 0;

                color: #b2b2b7;
                font-size: 14px;
                cursor: pointer;

                @media(max-width: 720px) {
                  width: 145px;
                }

                &:hover {
                  filter: brightness(0.9);
                }
              }

              .buttonSelectHoursActive {
                color: #fff;
                background-color: #004fff;
                border: 1px solid #004fff;
              }
            }
          }


          .profile{
            display: flex;
            justify-content: flex-start;

            .active{
              background-color: #00D36A;
              color: #fff !important;
              font-size: 18px;
              font-weight: 500;
              width: 126px;
              border: none;
              margin-left: 240px;
            }
          }

          .addInput{
            width: 128px;
            height: 32px;

            margin: 0 24px;
            color: #87868F;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            background: transparent;
            font-family: 'Work Sans', sans-serif;
            cursor: pointer;
          }

          .timezoneCard{
            margin-bottom: 0;

            div:nth-child(2) {
              width: 480px !important;

              @media(max-width: 720px) {
                width: 100% !important;
              }

              input {
                width: 100% !important;
              }
              ul {
                width: 480px !important;

                @media(max-width: 720px) {
                  width: 100% !important;
                }

                li {
                  width: 100% !important;

                  @media(max-width: 720px) {
                    width: 100% !important;
                  }

                  button {
                    width: 100% !important;
                  }
                }
              }
            }
          }

          .inputs{
            gap: 12px;
            display: flex;
            align-items: center;

            @media(max-width: 720px) {
              gap: 0;
              flex-direction: column;
            }

            .timezoneCard{
              div:nth-child(2){
                width: 480px !important;

                @media(max-width: 720px) {
                  width: 100% !important;
                }
              }
            }

            .lineInputs{
              @media(max-width: 720px) {
                width: 100% ;

                select {
                  width: 100%
                }
              }

              button {
                display: flex;
                gap: 10px;
                align-items: center;
                justify-content: center;
                width: auto !important;
                padding: 8px 12px;
              }

              .MuiInput-input-14 {
                width: 215px;
                border: none;
                height: 19px;
                margin: 0;
              }

              .MuiFormControl-root-30 {
                border: 1px solid;
                border-radius: 26px;
                border: 1px solid #B2B2B7;
              }

              input{
                width: 220px;

                @media(max-width: 720px) {
                  width: -webkit-fill-available !important;
                }
              }
            }

            p{
              color: #87868F;
              font-size: 11px;
              margin-top: 22px;

              @media(max-width: 720px) {
                margin: 0 0 15px;
              }
            }
          }

          button.password{
            width: auto;
            padding: 8px 12px;
            border-radius: 26px;
            margin-left: 0;
            background: transparent;
            border: 1px solid #B2B2B7;
            color: #403F4C;
            font-family: 'Quicksand', sans-serif;
            font-size: 14px;
            cursor: pointer;
            font-weight: 100;
            margin: 2px 0 44px 0;
          }

          .notification{
            display: flex;

            @media(max-width: 720px) {
              flex-direction: column;
              margin-bottom: 15px;
            }

            .switch__container{
              width: auto;
              margin: 0 0 0 23px;

              @media(max-width: 720px) {
                margin: 0px;
              }

              span{
                color: #707070;
                font-size: 12px;
                margin-left: 47px;
                font-family: 'Quicksand', sans-serif;
              }
            }

            span.delete{
              width: 55px;
              font-weight: bold;
              margin: 11px 0 0 0;
            }

            .switchBox{
              display: flex;

              @media(max-width: 720px) {
                align-items: center;
                justify-content: space-between;
              }
            }
          }

          span.delete {
            color: red;
            font-size: 10px;
            font-weight: bold;
            margin-top: 30px;
            float: left;
          }

          button.jsx-4179805763 {
            width: 460px;
            height: 32px;
            border-radius: 26px;
            border: 1px solid #B2B2B7;
            padding-left: 10px;
            margin: 0 0 1px 0 !important;
            background: #B2B2B7;
            border-radius: 0;
          }

          button.focus.jsx-4179805763  {
            background: #B2B2B7;
          }

          button.delete{
            width: 83px;
            height: 22px;
            border-radius: 26px;
            background: transparent;
            border: none;
            color: #FF5666;
            cursor: pointer;
            font-size: 11px;
            font-weight: bold;
            margin: 25px 0 20px 7px;

          }
        }
      }

      .buttonSave{
        display: flex;
        justify-content: flex-end;

        button{
          padding: 10px 20px;
          height: 38px;
          border-radius: 26px;
          background: #004FFF;
          border: 1px solid #004FFF;
          color: #fff;
          cursor: pointer;
          font-size: 14px;
          font-weight: bold;
          margin: 24px 0 30px 0;
          font-family: 'Work Sans',sans-serif;
        }
      }
    }

    .MuiInput-underline-15:before {
      border-bottom: none;
    }

    .MuiInput-underline-15:hover:not(.MuiInput-disabled-14):not(.MuiInput-focused-13):not(.MuiInput-error-16):before {
      border-bottom: none;
    }

    input.jsx-4179805763  {
      width: 480px;
      height: 32px;
      border-radius: 26px;
      border: 1px solid #B2B2B7;
      padding-left: 10px;
      margin-bottom: 15px;

      @media(max-width: 720px) {
        width: 100% !important;
      }
    }

    .inputManage{
      border-color: #B2B2B7 !important;
    }
  }
`;

export const PlansAccountStyles = styled.div`
  width: 95%;
  max-width: 1300px;
  margin: 0 auto;

  .tabs {
    width: 100%;
    margin-bottom: 36px;

    .buttons{
      display: flex;
      margin-top: 10px;
      justify-content: center;

      button{
        background-color: #004FFF;
        border: none;
        color: #fff;
        font-size: 14px;
        border-radius: 26px;
        width: auto;
        height: 38px;
        margin-top: 50px;
        cursor: pointer;
        font-family: 'Work Sans', sans-serif;
        font-weight: 900;
        padding: 0 12px 0 12px;
      }
    }

    .tab-list {
        padding-left: 0;

        .tabsContent{
            margin: 0 auto;
            width: 100%;
            text-align: center;

            .tab-list-item {
                display: inline-block;
                list-style: none;
                cursor: pointer;
                font-size: 15px;
                font-family: 'Quicksand', sans-serif;
                color: #ffffff;
                font-weight: 600;
            }

            .tab-list-active {
                color: #ffffff;
                font-weight: 700;
                border-bottom: none;
                font-size: 15px;
                font-family: 'Quicksand', sans-serif
            }
        }
    }

    .box{
      width: unset;
      height: 100%;
      background-color: #fff;
      margin-top: 25px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: row;
      padding: 15px 15px;
      gap: 10px;
      border-radius: 10px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      flex-wrap: wrap;
    }

    .planBox{
      .box {
        flex-direction: column;

        .buttons{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: flex-end;
            margin: 25px 35px 25px 0;
            padding: 0 15px 0 15px;
            cursor: pointer;

            button {
                background-color: transparent;
                border: 1px solid #787780;
                color: #403F4C;
                font-weight: bold;
                font-size: 11px;
                border-radius: 26px;
                width: 71px;
                height: 32px;
                margin-top: 9px;
                cursor: pointer;

                &:last-child{
                    background-color: #004FFF;
                    border: none;
                    color: #fff;
                    font-weight: bold;
                    font-size: 11px;
                    border-radius: 26px;
                    padding: 10px 20px;
                    height: 38px;
                    margin-top: 5px;
                    margin-left: 15px;
                    cursor: pointer;
                }
            }
        }
      }

      .PlansBox {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;

        @media(max-width: 720px) {
          gap: 20px;
          flex-direction: column;
        }


        &:first-child{
          margin-bottom: 0;
          border-bottom: none;
          padding-bottom: 0;
          min-width: 200px !important;
        }

        &:last-child{
          border-bottom: none;
        }

        .last{
          margin-bottom: 20px;

          @media(max-width: 720px) {
            margin-bottom: 0px;
          }
        }

        .plansLingo {
          min-width: 200px !important;

          @media(max-width: 720px) {
            width: 30%;
            min-width: 0 !important;
          }
        }

        .classes {
          min-width: 200px !important;
        }

        .level {
          min-width: 200px !important;
          justify-content: flex-end;

          @media(max-width: 720px) {
            min-width: 0 !important;
          }
        }

        .plans {
          gap: 16px;
          display: flex;
          align-items: center;


          &:nth-child(2) {
            max-width: 400px;
          }

          .changePlan {
            display: flex;
            flex-direction: column;
            align-items: start;
            padding-left: 10px;

            h2 {
              color: #403F4C;
              font-size: 18px;
              font-weight: bold;
              width: 100%;
              margin: 0 !important;
            }

              button {
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-size: 11px;
                border-radius: 26px;
                width: 86px;
                height: 22px;
                margin-top: 5px;
                margin-right: 5px;
                cursor: pointer;
                font-family: 'Quicksand', sans-serif;

              &:last-child {
                background-color: #fff;
                border: 1px solid #B2B2B7;
                color: #B2B2B7;
                font-size: 11px;
                border-radius: 26px;
                width: 93px;
                height: 22px;
                margin-top: 5px;
                cursor: pointer;
              }

              .fa{
                  margin-left: 10px;
              }
            }
          }

          .controlPlan {
              display: flex;
              flex-direction: row;
              justify-content: flex-start;
              align-items: center;
              width: 100%;
              gap: 40px;
              flex-wrap: wrap;

              .infos{
                  margin-bottom: 10px;
                  text-align: center;

                  @media(max-width: 720px){
                    margin-bottom: 0px;
                  }
              }

              h2{
                  font-size: 13px;
                  color: #9E9EA4;
                  font-weight: bold;
                  margin: 0;
                  padding: 0;
                  font-family: 'Quicksand', sans-serif;
              }

              h3{
                  font-size: 14px;
                  color: #403F4C;
                  margin: 3px 0 0 0;
                  padding: 0;
                  font-family: 'Quicksand',sans-serif;
                  font-weight: 100;
                  text-align: left;
                  max-width: 100%;
              }

              span{
                  color: #004FFF;
                  font-size: 22px;
                  font-weight: bold;

                  &:last-child{
                      color: #004FFF;
                      font-size: 14px;
                      font-weight: 50
                  }
              }
          }

          .numbers {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: -3px;
          }

          .stock {
            display: flex;
            flex-direction: column;
            width: 100%;

            @media(max-width: 720px){
               align-items: center;
               justify-content: center;
            }

            hr {
              height: 4px;
              background-color: #004FFF;
              border: none;
              margin: 9px 0 10px 0;
              opacity: 1;
            }

            span{
              color: #004FFF;
              font-size: 12px;
            }
          }

          .payment{
            flex-direction: column;
            margin-top: 7px;
            width: auto;

            h2{
              font-size: 15px;
              color: #87868F;
              font-weight: bold;
              margin: 0;
              padding: 0;
              font-family: 'Quicksand',sans-serif;
            }

            h3{
              font-size: 18px;
              color: #87868F;
              margin: 0;
              padding: 0;
              font-family: 'Quicksand',sans-serif;
              font-weight: 100;
              display: flex;
              align-items: center;

              img{
                margin-right: 8px;
              }
            }

            button{
              background-color: transparent;
              border: 1px solid #FF5666;
              color: #FF5666;
              font-size: 11px;
              border-radius: 26px;
              width: auto;
              height: 22px;
              margin-top: 8px;
              padding: 0 12px 0 12px;
              cursor: pointer;
            }

            select {
              width: 100%;
              height: 32px;
              border-radius: 26px;
              border: 1px solid #403F4C;
              padding-left: 10px;
              margin-bottom: 15px;
              color: #403F4C;
              margin-right: 10px;
              opacity: 0.4;
            }
          }

          .value {
            margin-top: 8px;

            h2{
              font-size: 15px;
              color: #87868F;
              font-weight: bold;
              margin: 0;
              padding: 0;
            }

            h3{
              font-size: 18px;
              color: #403F4C;
              font-weight: normal;
              margin-top: 4px;
              margin: 0;
              padding: 0;
              max-width: 100%;
              text-align: left;
            }

            button{
              background-color: #fff;
              border: 1px solid #787780;
              color: #403F4C;
              font-size: 11px;
              border-radius: 26px;
              width: 94px;
              height: 22px;
              margin-top: 8px;
              cursor: pointer;
            }
          }

          &:nth-child(2) {
            flex-direction: column;
          }

          &:last-child button{

            background-color: #fff;
            border: 1px solid #B2B2B7;
            color: #787881;
            font-size: 11px;
            border-radius: 26px;
            width: auto;
            height: 22px;
            margin-top: 5px;
            cursor: pointer;
            font-family: 'Quicksand', sans-serif;
            padding: 0 7px 0 7px;

            .fa{
              margin-left: 7px;
            }
          }

          .buttons{
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            margin-top: 25px;
            padding: 0 15px 0 15px;
            cursor: pointer;

            button{
              background-color: transparent;
              border: 1px solid #787780;
              color: #403F4C;
              font-weight: bold;
              font-size: 11px;
              border-radius: 26px;
              width: 71px;
              height: 38px;
              margin-top: 8px;
              cursor: pointer;

              &:last-child{
                background-color: #004FFF;
                border: none;
                color: #fff;
                font-weight: bold;
                font-size: 11px;
                border-radius: 26px;
                padding: 10px 20px;
                height: 38px;
                margin-top: 5px;
                cursor: pointer;
              }
            }
          }
        }

        .planCancel{
          color: #FF5666;
          padding: 4px 10px 0 10px;
          height: 23px;
          font-size: 15px;
          font-weight: bold;
          font-family: 'Quicksand', sans-serif;
        }
      }

      .row {
        @media(max-width: 720px) {
          display: flex;
          flex-direction: row !important;
          align-items: center !important;
          justify-content: space-between;
        }
      }
    }

    .pagamento{
      display: flex;
      align-items: center;
      gap: 40px;
      flex-wrap: wrap;
      justify-content: center;

        .plansButtons{
          min-width: 150px;
          display: flex;
          gap: 12px;

          .payment{
            display: flex;
            align-items: center;
            flex-direction: column;
            justify-content: center;

            @media(max-width: 720px) {
              button {
                height: 50px;
              }
            }

            h2 {
              color: #403f4c;
              font-weight: 500;
              font-size: 16px !important;
            }

            h3, span{
              text-transform: capitalize;
              width: 100%;
              font-size: 22px;
              color: #004FFF;
              font-weight: bold;
              font-family: 'Quicksand', sans-serif;
              margin: 10px 0;
              width: 100%;
              max-width: 66%;
              text-align: center;
            }
          }
        }

        .plans{
          min-width: 150px;

          .payment{
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;

            h2{
              font-size: 16px !important;
              color: #403f4c;
            }
            h3{
              text-transform: capitalize;
              width: 100%;

              @media(max-width: 720px) {
                text-align: center;
              }
            }
          }

        .paymentCard{
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            h2{
            font-size: 16px !important;
            color: #403f4c;
            }
            h3{
            text-transform: capitalize;
            font-size: 12px !important;
            max-width: unset !important;
            }
            span{
            text-transform: capitalize;
            font-size: 12px !important;
            max-width: unset !important;
            color: #004FFF;
            margin: 10px 0;
            }
        }
        }
    }

    .containerCarousel {
      display: flex;
      flex-direction: column;

      margin: 0 auto;
      max-width: 1200px;

      .carousel-container {
        width: 100%;
        margin: 30px 0;
        padding: 20px 0px;

        @media(max-width: 800px) {
          padding: 20px 45px;
        }

        @media(max-width: 720px) {
          width: auto;
          padding: 0px 20px 0;
        }

        @media(max-width: 380px) {
          width: auto;
          padding: 0px 7px 0;
        }
      }

      .sliderClass {
        background-color: red !important;
      }
    }

    .divButtonsPlan {
      gap: 12px;
      width: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      margin: 30px 0;
    }

    .inputManage{
      border-color: #B2B2B7 !important;
    }
  }
`;

export const LevelScoreAccountStyles = styled.div`
  width: 95%;
  margin: 0 auto;
  max-width: 1300px;

  .tabs{
    width: 100%;

    .tab-content{
      margin-bottom: 36px;

      .buttons-plans {
        display: flex;
        flex-direction: column;
        align-items: flex-end !important;

        .button-buy-more {
          background-color: #004FFF !important;
          color: #fff !important;
          font-size: 11px;
          font-family: "Quiscksand", sans-serif;
          font-weight: 500;
          width: auto !important;
          height: 22px !important;
          padding: 6px 10px;
          white-space: nowrap;
          margin-top: 7px !important;
          border: none !important;
        }
      }

      .buttons{
        display: flex;
        justify-content: center;
        margin-top: 10px;

        button{
          background-color: #004FFF;
          border: none;
          color: #fff;
          font-size: 14px;
          border-radius: 26px;
          width: auto;
          height: 38px;
          margin-top: 50px;
          cursor: pointer;
          font-family: 'Work Sans', sans-serif;
          font-weight: 900;
          padding: 0 12px 0 12px;
        }
      }
    }

    .box{
      width: unset;
      height: 100%;
      background-color: #fff;
      margin-top: 25px;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      flex-direction: row;
      padding: 15px 15px;
      gap: 10px;
      border-radius: 10px;
      box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
      flex-wrap: wrap;
    }

    .boxBig {
      width: 100%;
      display: flex;
      gap: 26px;
      margin: 0 auto;
      flex-direction: column;
      flex-wrap: wrap;

      border-bottom: 1px solid #ccc;

      &:last-child {
        border-bottom: none !important;
      }

      .itemBox {
        gap: 60px;
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;

        @media(max-width: 720px) {
          gap: 0px;
          flex-direction: column;
        }

        h5{
          margin: 0;
          padding: 0;
          color: #87868F;
          font-weight: bold;
        }

        span{
          color: #004FFF;
        }

        .levelTop {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          max-width: 160px;

          @media(max-width: 720px) {
            max-width: 100%;
          }

          .levelTopLinguage {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;

            .boxLanguage {
              display: flex;
              width: 100%;
              justify-content: space-between;
              flex-direction: column;

              h5{
                padding: 0;
                margin: 0;
                color: #87868F;
              }

              .language {
                display: flex;
                margin: 7px 0 13px 0;
                align-items: center;

                img {
                  margin: 0 8px 0 0;
                }

                h5{
                  font-size: 18px;
                  color: #87868F;
                  margin: 0;
                  padding: 0;
                  font-family: 'Quicksand',sans-serif;
                  font-weight: 100;
                }
              }
            }
          }

          .columLevel {
            justify-content: flex-end;
            display: flex;
            width: 100%;

            h5 {
              text-align: right;
              padding: 0;
              margin: 0;
              color: #87868F;
            }
          }
        }

        .levelContent {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          @media(max-width: 720px) {
            flex-wrap: wrap;
            margin-bottom: 20px;
          }
        }

        .another-grades{
          align-items: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }

        .grades {
          display: flex;
          flex-direction: row;
          align-items: center;


          h6 {
            margin:  0 10px 0 0;
            color: #87868F;
            font-size: 15px;
            font-family: 'Quicksand', sans-serif;
            font-weight: bold;
          }

          h5{
            padding: 0;
            margin: 0;
            color: #87868F;
            font-size: 14px;
            font-family: 'Quicksand', sans-serif;
            font-weight: normal;
            font-weight: bold;
            text-align: center;

            span {
              color: #004FFF;
              font-weight: bold;
            }
          }
        }
      }
    }
  }
`;

export const NotificationAccountStyles = styled.div`
  width: 95%;
  margin: 0 auto;
  max-width: 1300px;

  .tabs{
    width: 100%;

    .tab-content {
      margin-bottom: 36px;

      .box{
        width: unset;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: row;

        margin-top: 25px;
        padding: 15px 15px;
        border-radius: 10px;
        background-color: #fff;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);

        &.boxCalendarLink {
          flex-direction: column;

          .calendarLink {
            width: 100%;
            display: flex;
            flex-direction: column;
          }

          .calendarLinkHeader {
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-bottom: 10px;

            h2 {
              color: #403F4C;
              font-size: 18px;
              font-weight: 400;
              font-family: 'Quicksand', sans-serif;
            }

            p {
              margin: 8px 0 0 0;
              color: #6D6A75;
              font-size: 16px;
              font-weight: 400;
              font-family: 'Quicksand', sans-serif;
            }
          }

          .switch__container {
            width: auto !important;
            margin: -10px;
          }

          .calendarLinkList {
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 0;
          }

          .calendarLinkItem {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 18px 0;
            margin: 0;

            &:not(:last-child) {
              // border-bottom: 1px solid #E4E8EE;
            }

            @media(max-width: 720px) {
              gap: 12px;
              flex-direction: row;
            }
          }

          .calendarLinkLeft {
            display: flex;
            align-items: center;
            gap: 16px;
          }

          .calendarLinkIcon {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #F7F8FA;
            border: 1px solid #EEF0F4;

            img {
              width: 22px;
              height: 22px;
              object-fit: contain;
            }
          }

          .calendarLinkIconOutlook {
            background: #F7F8FA;

            span {
              color: #004FFF;
              font-weight: 700;
              font-family: 'Quicksand', sans-serif;
            }
          }

          .calendarLinkText {
            display: flex;
            flex-direction: column;

            h3 {
              margin: 0;
              color: #403F4C;
              font-size: 16px;
              font-weight: bold;
              font-family: 'Quicksand', sans-serif;
            }

            span {
              margin-top: 2px;
              width: auto;
              color: #97979E;
              font-size: 14px;
              font-weight: 400;
              font-family: 'Quicksand', sans-serif;
            }
          }

          .calendarLinkRight {
            display: flex;
            align-items: center;

            .calendarConnected {
              color: #8ce196;
              font-weight: 600;
            }
          }

          .calendarConnectBtn {
            background-color: transparent;
            border: 1px solid #787780;
            color: #403F4C;
            font-weight: bold;
            font-size: 12px;
            border-radius: 26px;
            padding: 6px 14px;
            cursor: pointer;

            &:disabled {
              opacity: 0.6;
              cursor: not-allowed;
            }
          }

        }

        .infoNotification {
          width: 100%;

          h2 {
            color: #403F4C;
            font-size: 18px;
            font-weight: 400;
            font-family: 'Quicksand', sans-serif;
          }

          ul {
            width: 100%;
            display: flex;
            flex-direction: column;
            margin-top: 20px;

            li {
              width: 100%;
              height: 50px;
              display: flex;
              align-items: center;
              justify-content: space-between !important;
              padding: 12px 0;

              @media(max-width: 720px) {
                justify-content: space-between;
              }

              margin: 0;

              &:not(:last-child) {
                border-bottom: 1px solid #E4E8EE;
              }

              .switch__container {
                display: flex;
                align-items: center !important;
                width: auto !important;
                margin: 0;
              }

              .notificationLeft {
                display: flex;
                align-items: center;
                gap: 12px;
              }

              .notificationIcon {
                width: 42px;
                height: 42px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: #F7F8FA;
                border: 1px solid #EEF0F4;

                img, svg {
                  width: 18px;
                  height: 18px;
                  object-fit: contain;
                }
              }

              span {
                width: 175px;
                color: #403F4C;
                font-size: 15px;
                font-family: 'Quicksand', sans-serif;
              }

              p {
                margin: 0;
                color: #403F4C;
                font-size: 16px;
                font-weight: bold;
                font-family: 'Quicksand', sans-serif;
              }

              .notificationLeft {
                p {
                  width: auto;
                }
              }

              .switch__container {
                @media(max-width: 720px) {
                  width: auto !important;
                  margin: 0;
                }
              }
            }
          }
        }
      }
    }
  }
`;
